import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';

import { DeveloperProject } from './../../models/real-estates/real-estates.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { ContainedMany } from './../../models/editors/contained-many.model';
import { Switch } from './../../models/editors/switch.model';

@Component({
  selector: 'swb-developer-project-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class DeveloperProjectDetailComponent extends FormDetailBase<DeveloperProject> implements OnInit {
  public url = 'developer-projects';
  protected _redirect = './real-estate';

  public entity = new DeveloperProject({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název projektu',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Popis projektu',
        validators: [],
        isMultilang: true,
        wysiwyg: 'page-detail',
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        wysiwyg: false,
        boundTo: 'custom_seo_data'
      }),
      new Switch({
        key: 'is_short',
        label: 'Redukované zobrazení nemovitostí',
        labelFalse: 'Plné zobrazení nemovitostí',
        defaultValue: true
      }),
      new Contained({
        key: 'estate_agent_id',
        label: 'Realitní makléř',
        entity: this.entity.estate_agent,
        upload: false,
        apiUrl: 'estate-agents'
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        entities: this.entity.files,
        files: this.entity.files,
        apiUrl: 'files',
        upload: true,
        imgOnly: false
      }),
      new ContainedMany({
        key: 'estates',
        label: 'Nemovitosti',
        entities: this.entity.estates,
        upload: false,
        apiUrl: 'estates'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
